import { FormInitializerReturnType } from 'src/Configuration/validation'
import { EdsnModel } from '../../models/wallbox-configuration/wallbox-configuration-settings-form.model'
import { WallboxConfigurationModel } from '../..'
import { object } from 'yup'
import useWallboxSettingsFormValidationFields from '../use-wallbox-settings-form-field-validations'
import { FALLBACK_VALUE_EDSN } from '../../components'

/**
 * Initializes the form for editing wallbox default settings
 * @param model WallboxConfigurationModel
 * @returns initialValues and validationSchema for wallbox default settings form
 */
export const useWallboxEdsnFormInitializer = (model?: WallboxConfigurationModel): FormInitializerReturnType<EdsnModel, EdsnModel> => {
  const validationFields = useWallboxSettingsFormValidationFields()

  const initialValues = {
    sunModeActive: model?.sunModeActive ?? false,
    chargeStopHysteresis: model?.chargeStopHysteresis ?? 0,
    minChargePower: model?.minChargePower ?? FALLBACK_VALUE_EDSN.minChargePower,
    maxChargePower: model?.maxChargePower ?? FALLBACK_VALUE_EDSN.maxChargePower,
    maxDischargePower: model?.maxDischargePower ?? FALLBACK_VALUE_EDSN.maxDischargePower,
    lowerChargePowerLimit: model?.lowerChargePowerLimit ?? FALLBACK_VALUE_EDSN.lowerChargePowerLimit,
    upperChargePowerLimit: model?.upperChargePowerLimit ?? FALLBACK_VALUE_EDSN.upperChargePowerLimit,
    lowerDischargePowerLimit: model?.lowerDischargePowerLimit ?? FALLBACK_VALUE_EDSN.lowerDischargePowerLimit,
    upperDischargePowerLimit: model?.upperDischargePowerLimit ?? FALLBACK_VALUE_EDSN.upperDischargePowerLimit,
  }

  const validationSchema = object().shape({
    sunModeActive: validationFields.sunModeActiveField(),
    chargeStopHysteresis: validationFields.chargeStopHysteresisField(),
    minChargePower: validationFields.minChargePowerField(),
    maxChargePower: validationFields.maxChargePowerField(),
    maxDischargePower: validationFields.maxDischargePowerField(),
    lowerChargePowerLimit: validationFields.lowerChargePowerLimitField(),
    upperChargePowerLimit: validationFields.upperChargePowerLimitField(),
    lowerDischargePowerLimit: validationFields.lowerDischargePowerLimitField(),
    upperDischargePowerLimit: validationFields.upperDischargePowerLimitField(),
  })
  return { initialValues, validationSchema }
}
